// define global variables for ESLint
/* global ajax_object */

const cookieFunctions = require('./cookies');
const getCookie = cookieFunctions.getCookie;
const setCookie = cookieFunctions.setCookie;

if ($.fn.owlCarousel) {
    $.fn.owlCarousel.header = {
        items: 1,
        loop: false,
        rewind: true,
        nav: true,
        navText: ['', ''],
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        dots: false,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true
    };
    $.fn.owlCarousel.news = {
        items: 1,
        loop: true,
        nav: true,
        navText: ['', ''],
        dots: false,
    };
    $.fn.owlCarousel.quoteTop = {
        items: 1,
        loop: true,
        nav: false,
        margin: 15,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        freeDrag: false,
        dots: false,
    };

    $.fn.owlCarousel.quoteBottom = {
        items: 3,
        loop: true,
        nav: true,
        center: true,
        navText: ['', ''],
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        freeDrag: false,
        dots: false,
    };
    $.fn.owlCarousel.team = {
        loop: false,
        nav: true,
        dots: false,
        navText: ['', ''],
        margin: 30,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            575: {
                items: 2,
            },
            767: {
                items: 3,
            },
        }
    };
}

$.fn.accessKeys = function (options) {
    const $elements = $(this);
    $elements.each(function (i, e) {
        let data = $(this).data('access');

        if (data) {
            if (typeof data != 'object') {
                data = $.fn.accessKeys[data];
            }
            data = $.extend({}, $.fn.accessKeys.defaults, data, options);

            if ($(data.target).exists()) {
                let target = $(data.target).get(0);

                if ($(target).is(':hidden') || $(target).is(':disabled')) {
                    $(target).attr('tabindex', 0).addClass('no-focus');
                }


                target.accessKey = data.key;

                $(this).click(function (e) {
                    if (data.scroll) {
                        $('html,body').stop().animate({
                            scrollTop: $(target).offset().top - data.offset
                        }, data.duration, data.easing, function () {
                            target.focus();
                        });
                    } else {
                        target.focus();
                    }
                });
            } else {
                $(this).addClass('hide');
            }
        }
    });
};
$.fn.accessKeys.defaults = {
    scroll: true,
    easing: 'swing',
    duration: 800,
    offset: 0,
    target: undefined // default href
};

$(document).ready(function () {
    $('body:not(.single-team) .panel-layout').detach().prependTo($('main'));
})
$(document).on('ready.ns', function () {
    $('a[href*="#"]').not('[href="#"]').not('.no-link').click(function (event) {
        // On-page links
        if ($(this).attr('data-href') || (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname)) {
            // Figure out element to scroll to
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?


            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').stop().animate({
                    scrollTop: target.offset().top - Math.min($('header').outerHeight(), 85) - ($('#wpadminbar').length ? $('#wpadminbar').height() : 0) - 10
                }, 1000, function () {
                    // Callback after animation
                    // Must change focus!
                    let $target = $(target);
                    //$target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        //$target.focus(); // Set focus again
                    }
                });
            }
        }
    });

    setTimeout(function () {
        $('.owl-prev, .owl-next').each(function () {
            $(this).append('<span class="sr-only">' + $(this).attr('title') + '</span>');
        });
        $('.owl-item.cloned').each(function () {
            $(this).attr('aria-hidden', 'true');
        })
    }, 1000);

    $(document).on('click', '#next-step-address', function (e) {
        console.log('tet');
        if (!$(this).hasClass('active') && $('#billing_eu_vat_number').val()) {
            e.preventDefault();
            $('.eu-vat-error').remove();

            $('.checkout').block({
                message: null,
                overlayCSS: {
                    background: '#fff',
                    opacity: 0.6
                }
            });

            let message = '<li><strong>UID Nummer</strong> ist falsch.</li>';
            let $ele = $('<div class="woocommerce-NoticeGroup woocommerce-NoticeGroup-checkout eu-vat-error"><ul class="woocommerce-error" role="alert"><i class="fa fa-exclamation-circle"></i>' + message + '</ul></div>');
            if ($('#billing_eu_vat_number_field').hasClass('woocommerce-invalid')) {
                if (!$('.woocommerce-NoticeGroup ul').length) {
                    $('.woocommerce-checkout').prepend($ele);
                } else {
                    $('.woocommerce-NoticeGroup ul').append(message);
                }
                $('html, body').animate({
                    scrollTop: 0,
                });
                $('.checkout').unblock();
            } else {
                $.post(ajax_object.ajax_url, {
                    action: 'alg_wc_eu_vat_validate_action',
                    alg_wc_eu_vat_to_check: $('#billing_eu_vat_number').val(),
                    billing_country: $('#billing_country').val(),
                }, function (data) {
                    if (data == 1) {
                        $('#next-step-address').addClass('active').click();
                    } else {
                        $('#billing_eu_vat_number_field').addClass('woocommerce-invalid');
                        if (!$('.woocommerce-NoticeGroup ul').length) {
                            $('.woocommerce-checkout').prepend($ele);
                        } else {
                            $('.woocommerce-NoticeGroup ul').append(message);
                        }
                        $('html, body').animate({
                            scrollTop: 0,
                        });
                    }
                    $('.checkout').unblock();
                });
            }

        }
    });

    setTimeout(function () {
        $(window).resize();
        $('.owl-carousel').trigger('refresh.owl.carousel');
    })

    $('.product-remove .remove').each(function () {
        $(this).tooltip({
            title: $(this).attr('aria-label'),
        });
    });

    $('.t-slider .owl-carousel').on('changed.owl.carousel', function () {
        $(window).resize();
    });

    let f = localStorage.getItem('font');
    localStorage.clear();
    localStorage.setItem('font', f);

    $('.addtoany_shortcode img').replaceSVG();


    $('[data-cat]').fadeOut(0);
    $('[data-cat-select]').click(function (e) {

        if ($(this).children('a').attr('href').indexOf('#') === 0) {
            $(this).toggleClass('active').siblings().removeClass('active');

            if (!$('[data-cat-select].active').exists()) {
                $(this).siblings('.default').addClass('active');
            }

            let cat = $('[data-cat-select].active').data('cat-select');

            setTimeout(function () {
                if ($('[data-cat]:visible').exists()) {
                    $('[data-cat]:visible').stop().fadeOut({
                        done: function () {

                            $('[data-cat="' + cat + '"]').css({
                                opacity: 0,
                                display: 'block',
                            }).each(function (i, e) {
                                setTimeout(function () {
                                    $(this).stop().animate({
                                        opacity: 1,
                                    });
                                }.bind(this), i * 50);
                            });
                        }
                    });
                } else {

                    $('[data-cat="' + cat + '"]').css({
                        opacity: 0,
                        display: 'block',
                    }).each(function (i, e) {
                        setTimeout(function () {
                            $(this).stop().animate({
                                opacity: 1,
                            });
                        }.bind(this), i * 80);
                    });
                }
            }.bind(this), 0);
        }

    });

    let hash = window.location.hash.slice(1);
    if (hash) {
        let $select = $('[data-cat-select="' + hash + '"]');
        if ($select.exists()) {
            $select.get(0).click();
        }
    } else {
        $('[data-cat="' + $('.default[data-cat-select]').attr('data-cat-select') + '"]').fadeIn(0);
    }


    $('.nm-more-link').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('active').parents('.nm-category-wrapper').toggleClass('active');
        $(this).prev().slideToggle();
    });


    $('.ar-more').click(function (e) {
        $('.ar-infinite').infiniteScroll();
        $(this).fadeOut();
    });


    $('.zz-item').on('scroll.animation', function (e) {
        $(this).find('.counter-number').not('.completed, .started').each(function () {
            $(this).addClass('started');
            $(this).prop('Counter', 0).animate({
                Counter: $(this).text()
            }, {
                duration: 3000,
                easing: 'swing',
                step: function (now) {
                    $(this).text(Math.ceil(now));
                },
                complete: function () {
                    $(this).removeClass('started');
                    $(this).addClass('completed');
                }
            });
        });
    });

    $(window).resize(function (e) {
        resize();
        if ($(window).width() < 1280) {
            $('.newskopf-widget .newsmeta-aside-col').detach().appendTo('.comments-section');
        } else {
            $('.newsmeta-aside-col').detach().appendTo('.newskopf-widget > .container > .row');
        }

        if ($(window).width() <= 1280) {
            $('.h-sp').height(72);
        } else {
            $('.h-sp').height(110);
        }
    });

    function resize() {
        let cu = $('.t-sliders').height();
        let he = $('.t-sliders').find('.filter-item-active').height();
        setTimeout(function () {
            $('.t-sliders').height(he);
        }, cu > he ? 400 : 0);
    }

    $('.t-items').on('change.ns.filter', resize);
    $('.t-items').trigger('apply.ns.filter');
    setTimeout(function () {
        $(window).trigger('resize');
    }, 0);


    $('.t-items').on('change.ns.filter', function (e) {
        let $active = $(this).find('.filter-active');
        if ($active.exists()) {
            $(this).find('.filter-apply').not($active).addClass('inactive');
        } else {
            $(this).find('.filter-apply').removeClass('inactive');
        }
    });

    let mouseDown;
    $(document).on('mousedown', '.btn, .no-focus, a, button, [tabindex]', function (e) {
        if ($(e.currentTarget).is('.btn, a, button, [tabindex]:not(.no-focus)') && !$(e.target).is('input, textarea, #header-search, .header-search, .page-access-key')) {
            mouseDown = true;
        }
    });
    $(document).on('focus', 'input, button, a, [tabindex]', function (event) {
        if (mouseDown) {
            event.target.blur();
        }
        setTimeout(function () {
            if (mouseDown) {
                event.target.blur();
                mouseDown = false;
            }
        }, 0);
    });

    let $bc = $('[data-add-bc]');
    if ($bc.exists()) {
        let bcData = $bc.data('add-bc');
        let $clone = $bc.children().first().clone();
        $clone.find('a').attr('href', bcData.link).text(bcData.title);
        $clone.insertAfter($bc.children().eq(bcData.pos - 1));
    }
    if (window.location.href == $('.current_page_item a').attr('href') && $('.current_page_item').parent('.sub-menu').length && $('body.single-post').length) {
        let already = false;
        $('.bc-items a').each(function () {
            if ($(this).attr('href') == window.location.href) {
                already = true;
                return false;
            }
        });
        if (!already) {
            let $el = $('.current_page_item a');
            let $bc = $('.bc-items');
            let $clone = $bc.children().first().clone();
            $clone.find('a').attr('href', $el.parents('.sub-menu').prev().attr('href')).text($el.parents('.sub-menu').prev().text());
            $clone.insertAfter($bc.children().eq(0));
        }
    }

    if ($('#commentform').exists()) {
        $('#commentform').addClass('content').find('label').each(function (e) {
            let fo = $(this).attr('for');
            let text = $(this).text();
            $(this).hide();
            $('#' + fo).attr('placeholder', text);
        });
    }

    $('.header-font-plus, .header-font-minus').click(function (e) {
        let fontSize = parseInt($('body').attr('data-font-size')) || 0;
        let step = parseInt($(this).attr('data-font-step')) || 1;

        let value = fontSize + step;
        if (value < 3 && value > -2) {
            $('body').attr('data-font-size', fontSize + step);
            //setCookie('font', value, 365);
            localStorage.setItem('font', value);
            console.log(localStorage.getItem('font'));
        }
    });

    $('.access-key').accessKeys();

    $('.header-hamburger').click(function (e) {
        $('body').toggleClass('header-open');
        $('.hamburger').toggleClass('open');

        $('.header-mobile').fadeToggle();
    });

    $('.nav-item').hover(function (e) {
        if (!$('body').hasClass('lg')) {
            $(this).addClass('active');
        }
    }, function (e) {
        if (!$('body').hasClass('lg')) {
            $(this).removeClass('active');
        }
    });

    $('.nav-item a').focus(function (e) {
        if (!$('body').hasClass('lg')) {
            $(this).parent().addClass('active');
        }
    }).blur(function (e) {
        if (!$('body').hasClass('lg')) {
            $(this).parent().removeClass('active');
        }
    });
    $('.nav-item .nav-item a').focus(function () {
        if (!$('body').hasClass('lg')) {
            $(this).parent().parent().parent().addClass('active');
        }
    }).blur(function () {
        if (!$('body').hasClass('lg')) {
            $(this).parent().parent().parent().removeClass('active');
        }
    })


    $('.nav-arrow').click(function (e) {
        $(this).parent().toggleClass('active');
        $(this).prev().slideToggle();
    });

    // bugfix
    $('.btn').css('overflow', 'visible');
    setTimeout(function () {
        $('.btn').css('overflow', 'hidden');
    }, 0);


    $('.header-contrast').click(function (e) {
        let state = getCookie('contrast');
        let isContrast = !state || state == 'false';

        setCookie('contrast', isContrast, 365);
        location.reload();
    });


    $('.panel-grid').each(function (i, e) {
        if ($(this).children().length > 1) {
            $(this).children().addClass('multi-col');
        }
    });

    $('.single-team').find('.header-widget, .breadcrumbs-section').detach().prependTo('main');

    setTimeout(function () {
        $('.team-widget').find('.filter-apply').first().click();
    }, 0);

    $('.k-items .link-wrapper-inner').click(function (e) {
        if ($(this).attr('href').indexOf('#') === 0) {
            if ($(window).width() <= 575) {
                $('html,body').animate({
                    scrollTop: $('.k-posts').offset().top - 75
                });
            } else if ($('.k-posts-container').exists()) {
                $('html,body').animate({
                    scrollTop: $('.kategorien-widget').offset().top - 75
                });
            }
        }
    });

    $('.zahlenwerte-widget').each(function () {
        let $col = $(this).parents('.multi-col');
        console.log($col);
        if ($col.exists()) {
            if ($col.is(':first-child')) {
                $(this).addClass('zw-padding-right');
            } else if ($col.is(':last-child')) {
                $(this).addClass('zw-padding-left');
            }
        }
    });

    $('[autocomplete="country"]').change(function () {
        setTimeout(function () {
            $('[autocomplete="country"]').removeAttr('tabindex').removeAttr('aria-hidden');
        })
    }).removeAttr('tabindex').removeAttr('aria-hidden');


    setTimeout(function () {
        $('#billing_country_field, #billing_title_field, #shipping_title_field, #shipping_country_field')
            .find('.woocommerce-input-wrapper')
            .addClass('quantity quantity-select')

        $('select').change(function () {
            setTimeout(function () {
                $(this).removeClass('select2-hidden-accessible');
            }.bind(this), 0);
        });

        let $wrup = $('<div>', {
            class: 'quantity quantity-select wc-asad'
        });
        $('.variations select').wrap($wrup);

        $('.select2-hidden-accessible').removeClass('select2-hidden-accessible');

        jQuery('<div class="quantity-nav"><div class="quantity-button quantity-up"><img src="/app/themes/love-it/dist/assets/img/arrow_small.svg" alt="" width="10" height="10"></div><div class="quantity-button quantity-down"><img src="/app/themes/love-it/dist/assets/img/arrow_small.svg" alt="" width="10" height="10"></div></div>').insertAfter('.quantity input, .quantity select');
        jQuery('.quantity').each(function () {
            let spinner = jQuery(this),
                input = spinner.find('input[type="number"]'),
                btnUp = spinner.find('.quantity-up'),
                btnDown = spinner.find('.quantity-down'),
                min = input.attr('min'),
                max = input.attr('max');

            btnUp.click(function () {
                let oldValue = parseFloat(input.val());
                let newVal = oldValue;
                if (max && oldValue >= max) {
                    newVal = oldValue;
                } else {
                    newVal = oldValue + 1;
                }
                spinner.find("input").val(newVal);
                spinner.find("input").trigger("change");
            });

            btnDown.click(function () {
                let oldValue = parseFloat(input.val());
                let newVal = oldValue;
                if (oldValue <= min) {
                    newVal = oldValue;
                } else {
                    newVal = oldValue - 1;
                }
                spinner.find("input").val(newVal);
                spinner.find("input").trigger("change");
            });

        });

        $('.woocommerce-address-fields__field-wrapper p, .woocommerce-billing-fields__field-wrapper p, .woocommerce-shipping-fields__field-wrapper p').each(function () {
            if ($(this).attr('style') == 'display: none') {
                $(this).remove();
            }
            $(this).find('input').attr('placeholder', $(this).find('label').text());
        });
        $('.woocommerce-account .addresses .title .edit').each(function () {
            $(this).appendTo($(this).parents('.woocommerce-Address'));
        });

        $('.em-toggle').click(function () {
            $(this).toggleClass('active');
        });

        $('#billing_country_field, #billing_title_field, #shipping_title_field, #shipping_country_field').find('.woocommerce-input-wrapper').removeClass('woocommerce-input-wrapper');

        setTimeout(function () {
            $(window).resize();
        }, 100);
    }, 0);
});
